import { useCallback, useSyncExternalStore } from "react";

const KEY = "innvaer-theme";
const listeners = new Set();

export function readTheme() {
  try {
    return localStorage.getItem(KEY) === "dark" ? "dark" : "light";
  } catch {
    return "light";
  }
}

let current = readTheme();

export function applyTheme(theme) {
  current = theme;
  const root = document.documentElement;
  root.classList.toggle("dark", theme === "dark");
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute("content", theme === "dark" ? "#0d1118" : "#1d4f99");
  try { localStorage.setItem(KEY, theme); } catch { /* ignore */ }
  listeners.forEach((l) => l());
}

const subscribe = (cb) => { listeners.add(cb); return () => listeners.delete(cb); };
const getSnapshot = () => current;

/** Light is the default (per design guidelines). Dark mode is opt-in and remembered. Shared across all components. */
export function useTheme() {
  const theme = useSyncExternalStore(subscribe, getSnapshot, () => "light");
  const setTheme = useCallback((t) => applyTheme(t), []);
  const toggle = useCallback(() => applyTheme(current === "dark" ? "light" : "dark"), []);
  return { theme, setTheme, toggle, isDark: theme === "dark" };
}
